/**
 * ProtectedRoute Component
 *
 * Wrapper component that protects routes requiring authentication.
 * Always uses loginWithRedirect (not popup) because the user is being
 * sent to a page they can't access — a full-page redirect makes more
 * sense here than opening a popup unexpectedly.
 * Shows loading spinner while authentication state is being determined.
 */

import { useAuth } from "../hooks/useAuth";
import { LoadingSpinner } from "./LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth();

  if (isLoading) {
    return <LoadingSpinner message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    loginWithRedirect();
    return <LoadingSpinner message="Redirecting to login..." />;
  }

  return <>{children}</>;
}
